import i18n from '../i18n'

// Just the symbol, for places that label a field rather than render an amount (the discount's $/%
// toggle). Intl is the only source of it, so read it off a formatted zero.
export function currencySymbol(currency) {
  if (!currency?.code) { return '$' }

  try {
    const parts = new Intl.NumberFormat(i18n.language || 'en', { style: 'currency', currency: currency.code }).formatToParts(0)
    return parts.find(part => part.type === 'currency')?.value || '$'
  } catch {
    // An unrecognised currency code makes Intl throw; the symbol is cosmetic, so fall back.
    return '$'
  }
}

export function displayWithCurrency(amount, currency, noDecimals = false) {
  noDecimals = currency?.zeroDecimal || noDecimals

  return new Intl.NumberFormat(i18n.language || 'en', {
    maximumFractionDigits: noDecimals ? 0 : 2,
    minimumFractionDigits: noDecimals ? 0 : 2,
    style: 'currency',
    currency: currency?.code,
  }).format(amount)
}
